export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_24.1e3ae408.jpg";